import { useTranslations } from 'next-intl';
import React, { useMemo } from 'react';

import { useDomainConfiguration } from '@/components/DomainConfigurationProvider';

type UnifiedCrewMember = {
    id: number;
    left: string;
    right: string;
};

const MovieCrew: React.FC = () => {
    const { movieDto } = useDomainConfiguration();
    const t = useTranslations();
    const crewDepartments: Array<[string, Array<UnifiedCrewMember>]> = useMemo(() => {
        const crew = Object.entries(
            (movieDto?.credits?.crew ?? []).reduce(
                (acc, crewMember) => {
                    const crewDepartment = crewMember.department ?? 'other';
                    acc[crewDepartment] ??= [] as Array<UnifiedCrewMember>;
                    acc[crewDepartment].push({
                        id: crewMember.id,
                        left: crewMember.name,
                        right: t.has(`movie.crew-job.${crewMember.job}`)
                            ? t(`movie.crew-job.${crewMember.job}`)
                            : crewMember.job
                    });
                    return acc;
                },
                {} as Record<string, Array<UnifiedCrewMember>>
            )
        );
        const cast: Array<UnifiedCrewMember> = (movieDto?.credits?.cast ?? []).map((castMember) => {
            return {
                id: castMember.id,
                left: castMember.name,
                right: castMember.character
            };
        });
        return [[t('movie.cast'), cast], ...crew];
    }, [movieDto, t]);
    return (
        <div>
            {crewDepartments.map(([crewDepartment, crewMembers]) => (
                <div
                    key={crewDepartment}
                    className="pb-12">
                    <div className="text-body-bold-12 uppercase opacity-70 text-center tracking-[1.6px]">
                        {t.has(`movie.crew-job.${crewDepartment}`)
                            ? t(`movie.crew-job.${crewDepartment}`)
                            : crewDepartment}
                    </div>
                    {crewMembers.map((crewMember) => (
                        <div
                            key={`CrewMember#${crewMember.id}-${crewMember.left}-${crewMember.right}`}
                            className="flex flex-row space-x-8 py-4">
                            <div className="text-body-bold-14 w-1/2 text-right">{crewMember.left}</div>
                            <div className="text-body-14 w-1/2 text-left">{crewMember.right}</div>
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default MovieCrew;
